export enum PortalTeamDetailView {
    Overview = 'overview',
    Users = 'users',
    Credentials = 'credentials',
    Hierarchy = 'hierarchy',
}
